import { createRouter, createWebHistory } from 'vue-router';
import { ensureSession, isLoggedIn } from '../api/client';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('../layouts/AppLayout.vue'),
      children: [
        {
          path: '',
          name: 'overview',
          component: () => import('../views/OverviewView.vue'),
        },
        {
          path: 'applications',
          name: 'applications',
          component: () => import('../views/ApplicationsView.vue'),
        },
        {
          path: 'applications/:id',
          name: 'application-detail',
          component: () => import('../views/ApplicationDetailView.vue'),
        },
        {
          path: 'releases',
          name: 'releases',
          component: () => import('../views/ReleasesView.vue'),
        },
        {
          path: 'releases/new',
          name: 'release-upload',
          component: () => import('../views/ReleaseUploadView.vue'),
        },
        {
          path: 'releases/:id',
          name: 'release-detail',
          component: () => import('../views/ReleaseDetailView.vue'),
        },
        {
          path: 'channels',
          name: 'channels',
          component: () => import('../views/ChannelsView.vue'),
        },
        {
          path: 'push',
          name: 'push',
          component: () => import('../views/PushNotificationsView.vue'),
        },
        {
          path: 'activity',
          name: 'activity',
          component: () => import('../views/ActivityView.vue'),
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('../views/SettingsView.vue'),
        },
      ],
    },
  ],
});

let bootstrapped = false;

router.beforeEach(async (to) => {
  if (!bootstrapped) {
    bootstrapped = true;
    // Restore HttpOnly cookie session after reload / browser restart.
    await ensureSession();
  }

  if (to.meta.public) {
    if (to.name === 'login' && isLoggedIn()) {
      return { path: '/' };
    }
    return true;
  }
  if (!isLoggedIn()) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  return true;
});

export default router;
